@if (isLoading()) {
  <div class="profile-info">
    <ngx-skeleton-loader
      count="1"
      appearance="line"
      [theme]="{ width: '40%', height: '40px', 'border-radius': '4px' }"
    />
    <div class="hint">
      <ngx-skeleton-loader
        count="1"
        appearance="line"
        [theme]="{
          width: '30%',
          height: '16px',
          'border-radius': '4px',
          'margin-top': '8px',
        }"
      />
    </div>
  </div>
  <div class="about">
    <ngx-skeleton-loader
      count="2"
      appearance="line"
      [theme]="{
        width: '100%',
        height: '24px',
        'border-radius': '4px',
      }"
    />

    <ngx-skeleton-loader
      count="1"
      appearance="line"
      [theme]="{
        width: '70%',
        height: '24px',
        'border-radius': '4px',
      }"
    />
  </div>
} @else {
  <div class="profile-info">
    <div class="name" dataTest="profile-name">{{ profile()?.username }}</div>
    @if (profile()?.display_name) {
      <div class="hint">
        <div class="item" dataTest="profile-display-name">
          {{ profile()?.display_name }}
        </div>
      </div>
    }
  </div>
  @if (profile()?.description) {
    <div class="about" [innerHTML]="profile()?.description | lineBreakToHtml" dataTest="profile-description"></div>
  }
}
